import * as React from 'react';

interface ILngLat {
  lng: number;
  lat: number;
}

// The mouse position over the map, kept outside React state: it changes on
// every mousemove, and only the coordinates panel needs to re-render for it,
// not the whole map.
let position: ILngLat = { lng: 0, lat: 0 };
const listeners = new Set<() => void>();

const MousePosition = {
  get: () => position,
  set: (p: ILngLat) => {
    position = p;
    listeners.forEach(l => l());
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  }
};

/**
 * Returns the current mouse position over the map, re-rendering the calling
 * component whenever it changes.
 */
const useMousePosition = () => React.useSyncExternalStore(MousePosition.subscribe, MousePosition.get);

export { MousePosition, useMousePosition, ILngLat }
